<div class="container">
  <div class="cardBox " *ngIf="checkType=='add'">
    <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">

      <ion-row>
        <ion-col size="4">
          <div class="formLabelSemiBoldfs16 mb-5">Traits </div>
        </ion-col>
        <ion-col size="8" class="text-right">
          <img (click)="closeModal()" class="cp" src="././assets/icon/close_icon.png">
        </ion-col>
      </ion-row>
    </div>

    <mat-dialog-content class="p-0">
      <div style="padding: 0px 8px 8px 8px;">
        <ion-row>
          <!-- Input Field -->
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Traits</div>


            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput [(ngModel)]="performanceStandard" placeholder="Type here" [maxlength]="255" />
            </mat-form-field>
          </ion-col>

          <!-- Action Buttons -->
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="mt-20">
            <div class="d-flex mt-15">
              <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                (click)="saveConfirmation(null)" [disabled]="!performanceStandard.trim()"
                [ngStyle]="{opacity:!performanceStandard.trim()?0.5:1}">Save</button>
            </div>
          </ion-col>
        </ion-row>
      </div>


      <div class="p-10">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="table-container scrollable-table">
              <table>
                <thead>
                  <tr>
                    <th>SI<span class="red-cl">&nbsp;*</span></th>
                    <th>Traits<span class="red-cl">&nbsp;*</span></th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of ratingStandards; let i = index">
                    <td>{{ i + 1 }}</td>

                    <!-- Editable text field or plain label -->
                    <td *ngIf="editIndex !== i">{{ item.traitName }}</td>
                    <td *ngIf="editIndex === i">
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput [(ngModel)]="editableValue" [maxlength]="255" />
                      </mat-form-field>
                    </td>

                    <td>
                      <div class="d-flex mt-15">
                        <!-- Edit icon -->
                        <img *ngIf="editIndex !== i" class="ml-5 cp imgEdit" title="Edit" src="./assets/icon/edit.png"
                          (click)="onClickEditConfirm(i, item)" />

                        <!-- Close icon -->
                        <span *ngIf="editIndex === i" (click)="onClickCloseForDays()"
                          class="material-icons close p-10 cp fs-20" title="Cancel Edit">close</span>

                        <!-- Check/Save icon -->
                        <span *ngIf="editIndex === i" (click)="saveConfirmation(item)"
                          class="material-icons link p-10 cp fs-20" title="Confirm Edit">check</span>
                      </div>
                    </td>
                  </tr>
                </tbody>

              </table>
            </div>
          </ion-col>
        </ion-row>
      </div>
    </mat-dialog-content>
  </div>
  <div class="cardBox " *ngIf="checkType=='view'">

    <!-- <p style="text-align: center;"><em>(Applicable for Officer & Above Level Management Staff)</em></p> -->
    <ion-row>
      <ion-col size="10">
        <div>
          <h2 style="text-align: center; margin-left: 28%;">Probation and Confirmation Form</h2>
        </div>
      </ion-col>
      <ion-col size="2" class="text-right">
        <img (click)="closeModal()" class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <mat-dialog-content class="p-0">
      <div style="padding: 20px;">



        <ion-row class="ion-padding" style="border: 1px solid #ccc; border-radius: 8px; font-size: 16px;">
          <ion-col size="6" class="uniform-col">
            <div class="key-value-pair">
              <div class="key">Name:</div>
              <div class="value">{{ employee?.empName || lineManagerOrHODData[0]?.empName }}</div>
            </div>
          </ion-col>

          <ion-col size="6" class="uniform-col">
            <div class="key-value-pair">
              <div class="key">Empl. Code:</div>
              <div class="value">{{ employee?.emplCode || lineManagerOrHODData[0]?.emplCode }}</div>
            </div>
          </ion-col>

          <ion-col size="6" class="uniform-col">
            <div class="key-value-pair">
              <div class="key">Band:</div>
              <div class="value">{{ employee?.band || lineManagerOrHODData[0]?.band }}</div>
            </div>
          </ion-col>

          <ion-col size="6" class="uniform-col">
            <div class="key-value-pair">
              <div class="key">Grade:</div>
              <div class="value">{{ employee?.grade || lineManagerOrHODData[0]?.grade }}</div>
            </div>
          </ion-col>

          <ion-col size="6" class="uniform-col">
            <div class="key-value-pair">
              <div class="key">Designation:</div>
              <div class="value">{{ employee?.empDesignation || lineManagerOrHODData[0]?.empDesignation }}</div>
            </div>
          </ion-col>

          <ion-col size="6" class="uniform-col">
            <div class="key-value-pair">
              <div class="key">Department:</div>
              <div class="value">{{ employee?.empDept || lineManagerOrHODData[0]?.empDept }}</div>
            </div>
          </ion-col>

          <ion-col size="6" class="uniform-col">
            <div class="key-value-pair">
              <div class="key">Education:</div>
              <div class="value">{{ employee?.finalEducation || lineManagerOrHODData[0]?.finalEducation }}</div>
            </div>
          </ion-col>

          <ion-col size="6" class="uniform-col">
            <div class="key-value-pair">
              <div class="key">Experience:</div>
              {{ employee?.experience ?? lineManagerOrHODData[0]?.experience ?? '-' }}
            </div>
          </ion-col>

          <ion-col size="6" class="uniform-col">
            <div class="key-value-pair">
              <div class="key">Date Of Joining:</div>
              <div class="value">{{ employee?.dateOfJoining || lineManagerOrHODData[0]?.dateOfJoining | date:
                'dd-MM-yyyy' }}</div>
            </div>
          </ion-col>

          <ion-col size="6" class="uniform-col">
            <div class="key-value-pair">
              <div class="key">Probation Due On:</div>
              <div class="value">{{ employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation | date:
                'dd-MM-yyyy' }}</div>
            </div>
          </ion-col>

          <ion-col size="6" class="uniform-col">
            <div class="key-value-pair">
              <div class="key">Present Salary:</div>
              <div class="value">{{ employee?.presentSalary || lineManagerOrHODData[0]?.presentSalary }}</div>
            </div>
          </ion-col>
        </ion-row>



        <p style="padding-top: 10px; font-size: 14px; line-height: 1.5;">
          The employee mentioned above is due to be confirmed in service on the date indicated above.
          You are therefore, requested to carefully evaluate his job performance as under and return this form
          to the HR & Administration Department positively within one week from the date of its receipt.
        </p>

        <div class="mt-10" style="overflow: hidden; border-radius: 10px; border: 1px solid #ccc;">
          <table border="1" cellpadding="8" cellspacing="0"
            style="width: 100%; border-collapse: collapse; text-align: center;">
            <thead>
              <tr style="font-weight: bold; background-color: #f2f2f2">
                <td class="p-10" rowspan="2">Sl</td>
                <td class="p-10" rowspan="2">Traits</td>
                <td class="p-10" colspan="5">Points to be Evaluated</td>
              </tr>
              <tr>
                <td class="p-10">Outstanding</td>
                <td class="p-10">Very Good</td>
                <td class="p-10">Good</td>
                <td class="p-10">Average</td>
                <td class="p-10">Below Average</td>
              </tr>
            </thead>
            <tbody>


              <tr *ngFor="let item of ratings; let i = index">
                <td class="p-10">{{ i + 1 }}</td>
                <td class="p-10" style="text-align: left;">{{ item.traitName }}</td>
                <td class="p-10"
                  [class.readonly-cell]="!isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation )||checkhodbutEmployee||(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& (lineManagerOrHODData[0]?.whoChangedForm === 'Super Admin' ||lineManagerOrHODData[0]?.whoChangedForm === 'HR Admin'||lineManagerOrHODData[0]?.whoChangedForm === 'MD')">
                  <input type="checkbox" [(ngModel)]="ratings[i].outstanding"
                    (change)="selectOnlyOne(i, 'outstanding',item)"
                    [class.readonly-checkbox]="loggedInUserRole === 'Employee'" />
                </td>
                <td class="p-10"
                  [class.readonly-cell]="!isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation )||checkhodbutEmployee||(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& (lineManagerOrHODData[0]?.whoChangedForm === 'Super Admin' ||lineManagerOrHODData[0]?.whoChangedForm === 'HR Admin'||lineManagerOrHODData[0]?.whoChangedForm === 'MD')">
                  <input type="checkbox" [(ngModel)]="ratings[i].veryGood" (change)="selectOnlyOne(i, 'veryGood',item)"
                    [class.readonly-checkbox]="loggedInUserRole === 'Employee'" />
                </td>
                <td class="p-10"
                  [class.readonly-cell]="!isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation )||checkhodbutEmployee||(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& (lineManagerOrHODData[0]?.whoChangedForm === 'Super Admin' ||lineManagerOrHODData[0]?.whoChangedForm === 'HR Admin'||lineManagerOrHODData[0]?.whoChangedForm === 'MD')">
                  <input type="checkbox" [(ngModel)]="ratings[i].good" (change)="selectOnlyOne(i, 'good',item)"
                    [class.readonly-checkbox]="loggedInUserRole === 'Employee'" />
                </td>
                <td class="p-10"
                  [class.readonly-cell]="!isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation )||checkhodbutEmployee||(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& (lineManagerOrHODData[0]?.whoChangedForm === 'Super Admin' ||lineManagerOrHODData[0]?.whoChangedForm === 'HR Admin'||lineManagerOrHODData[0]?.whoChangedForm === 'MD')">
                  <input type="checkbox" [(ngModel)]="ratings[i].average" (change)="selectOnlyOne(i, 'average',item)"
                    [class.readonly-checkbox]="loggedInUserRole === 'Employee'" />
                </td>
                <td class="p-10"
                  [class.readonly-cell]="!isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation )||checkhodbutEmployee||(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& (lineManagerOrHODData[0]?.whoChangedForm === 'Super Admin' ||lineManagerOrHODData[0]?.whoChangedForm === 'HR Admin'||lineManagerOrHODData[0]?.whoChangedForm === 'MD')">
                  <input type="checkbox" [(ngModel)]="ratings[i].belowAverage"
                    (change)="selectOnlyOne(i, 'belowAverage',item)"
                    [class.readonly-checkbox]="loggedInUserRole === 'Employee'" />
                </td>

              </tr>

            </tbody>
          </table>
        </div>

        <div class="mt-10" style="overflow: hidden; border-radius: 10px; border: 1px solid #ccc;">
          <table border="1" cellpadding="8" cellspacing="0"
            style="width: 100%; border-collapse: collapse; text-align: center;">
            <thead>
              <tr>
                <td colspan="5" style="font-weight: bold; background-color: #f2f2f2" class="p-10">
                  Recommended By {{confirmationProbationWhomSetup}}
                </td>
              </tr>
              <tr>
                <td class="p-10"
                  [class.readonly-cell]="!isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation )||checkhodbutEmployee||(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& (lineManagerOrHODData[0]?.whoChangedForm === 'Super Admin' ||lineManagerOrHODData[0]?.whoChangedForm === 'HR Admin'||lineManagerOrHODData[0]?.whoChangedForm === 'MD')">
                  <label>
                    <input type="checkbox" [(ngModel)]="recommendation.confirmation"
                      (change)="selectOnlyOnerecommendation('confirmation')"
                      [class.readonly-checkbox]="loggedInUserRole === 'Employee'" /> Confirmation
                  </label>
                </td>

                <td class="p-10"
                 [class.readonly-cell]="!isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation )||checkhodbutEmployee||(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& (lineManagerOrHODData[0]?.whoChangedForm === 'Super Admin' ||lineManagerOrHODData[0]?.whoChangedForm === 'HR Admin'||lineManagerOrHODData[0]?.whoChangedForm === 'MD')">
                  <label>
                    <input type="checkbox" [(ngModel)]="recommendation.extension"
                      (change)="selectOnlyOnerecommendation('extension')" />
                    Extension of Probation
                  </label>
                </td>

                <td class="p-10"
                  [class.readonly-cell]="!isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation )||checkhodbutEmployee||(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& (lineManagerOrHODData[0]?.whoChangedForm === 'Super Admin' ||lineManagerOrHODData[0]?.whoChangedForm === 'HR Admin'||lineManagerOrHODData[0]?.whoChangedForm === 'MD')">
                  <label>
                    <input type="checkbox" [(ngModel)]="recommendation.promotion"
                      (change)="selectOnlyOnerecommendation('promotion')" />
                    Promotion by Designation
                  </label>
                </td>

                <td class="p-10"
                  [class.readonly-cell]="!isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation )||checkhodbutEmployee||(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& (lineManagerOrHODData[0]?.whoChangedForm === 'Super Admin' ||lineManagerOrHODData[0]?.whoChangedForm === 'HR Admin'||lineManagerOrHODData[0]?.whoChangedForm === 'MD')">
                  <label>
                    <input type="checkbox" [(ngModel)]="recommendation.increment"
                      (change)="selectOnlyOnerecommendation('increment')" />
                    Increase Salary
                  </label>
                </td>

                <td class="p-10"
                  [class.readonly-cell]="!isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation )||checkhodbutEmployee||(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& (lineManagerOrHODData[0]?.whoChangedForm === 'Super Admin' ||lineManagerOrHODData[0]?.whoChangedForm === 'HR Admin'||lineManagerOrHODData[0]?.whoChangedForm === 'MD')">
                  <label>
                    <input type="checkbox" [(ngModel)]="recommendation.termination"
                      (change)="selectOnlyOnerecommendation('termination')" /> Termination
                  </label>
                </td>
              </tr>
            </thead>
          </table>
        </div>

        <!-- Salary Details Table -->
        <!-- (loggedInUserRole == 'HOD')  -->
        <div class="mt-10" *ngIf="
        (checkhodbutEmployee&& confirmationProbationWhomSetup== 'HOD')||
         (loggedInUserRole == 'HOD' && confirmationProbationWhomSetup == 'HOD') 
        ||(confirmationProbationWhomSetup == 'HOD' && (loggedInUserRole=='Super Admin' 
        || loggedInUserRole=='HR Admin' 
        || loggedInUserRole=='PHI Admin' 
        || loggedInUserRole=='MD' 
        || loggedInUserRole=='Employee'))">

          <table border="1" cellpadding="8" cellspacing="0"
            style="width: 100%; border-collapse: collapse; margin-top: 10px;">
            <tr style=" background-color: #f2f2f2">
              <td style="font-weight: bold;" class="p-10">Comments of Head Of the Department</td>

            </tr>
            <tr>
              <!-- <td class="p-10">
              <textarea rows="3" cols="40" name="comments" style="border: hidden;"></textarea>
            </td> -->
              <td class="p-10"
                [class.readonly-cell]="!isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation )||checkhodbutEmployee||(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& (lineManagerOrHODData[0]?.whoChangedForm === 'Super Admin' ||lineManagerOrHODData[0]?.whoChangedForm === 'HR Admin'||lineManagerOrHODData[0]?.whoChangedForm === 'MD')">

                <textarea rows="3" cols="40" name="comments" style="border: hidden; width: 100%;"
                  [(ngModel)]="hodComment" [readonly]="loggedInUserRole!=='HOD'||checkSelfEmployee=='selfEmployee'"
                  maxlength="255"></textarea>
                <div style="font-size: 12px; text-align: right;">
                  {{ hodComment?.length || 0 }}/255
                </div>
                <!-- <div style="margin-top: 40px; text-align: right;">
                <input type="file" accept="image/*" (change)="handelSignFile($event)" *ngIf="!showImage"
                  style="margin: -60px;" />

              <div style="margin-top: 10px; text-align: right;">
                 
                  <div style="position: relative; display: inline-block; margin-left: auto; margin-right: 20px;"
                    *ngIf="showImage && signfileNameForApiAppend">
                    <img [src]="showImage" alt="" style="max-height: 80px; display: block;" />
                    <span class="material-icons close cp imgRemove" title="Remove"
                      *ngIf="showImage &&signfileNameForApiAppend"
                      style="position: absolute; top: -10px; right: -10px; background: #fff; font-size: 18px;"
                      (click)="onClickCancelUploadletterHead(signfileNameForApiAppend,'sign')">close</span>
                  </div>

                  <div>
                    <label>____________________</label><br />
                    <span style="font-size: 16px;margin-right: 20px;">Signature</span>
                  </div>
                </div> 

              </div> -->
              </td>

            </tr>
          </table>
        </div>


        <div class="mt-10" *ngIf="
 (checkhodbutEmployee && confirmationProbationWhomSetup !== 'HOD')|| 
     (  employee?.reportingManagerCode == empCode && confirmationProbationWhomSetup !== 'HOD')
       || (loggedInUserRole == 'Manager' && confirmationProbationWhomSetup == 'LINE_MANAGER')
       || (confirmationProbationWhomSetup == 'LINE_MANAGER' && 
            (loggedInUserRole == 'Super Admin' 
             || loggedInUserRole == 'HR Admin'
             || loggedInUserRole == 'PHI Admin'
             || loggedInUserRole == 'MD'
             || loggedInUserRole == 'Employee'))
       || (employee?.hodCode == employee?.reportingManagerCode && confirmationProbationWhomSetup !== 'HOD')
     ">



          <table border="1" cellpadding="8" cellspacing="0"
            style="width: 100%; border-collapse: collapse;  margin-top: 10px;">
            <tr style=" background-color: #f2f2f2">
              <td style="font-weight: bold;" class="p-10">Comments of Manager</td>

            </tr>

            <tr>
              <td class="p-10" [class.readonly-cell]="
      employee?.hodCode !== employee?.reportingManagerCode &&
      (
        !isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation) ||
        (
          (loggedInUserRole=='HOD' || loggedInUserRole=='Manager') &&
          (
            lineManagerOrHODData[0]?.whoChangedForm === 'Super Admin' ||
            lineManagerOrHODData[0]?.whoChangedForm === 'HR Admin' ||
            lineManagerOrHODData[0]?.whoChangedForm === 'MD'
          )
        )
      )
    ">

                <textarea rows="3" cols="40" name="comments" style="border: hidden;" [(ngModel)]="managerComment"
                  [readonly]=" !isEditable(employee?.dateOfConfirmation || lineManagerOrHODData[0]?.dateOfConfirmation)||(employee?.hodCode !== employee?.reportingManagerCode &&loggedInUserRole!=='Manager')||(checkSelfEmployee=='selfEmployee')"
                  maxlength="255"></textarea>
                <div style="font-size: 12px; text-align: right">
                  {{ managerComment?.length || 0 }}/255
                </div>
              </td>

            </tr>
          </table>
        </div>
        <div class="mt-10">
          <table border="1" cellpadding="8" cellspacing="0"
            style="width: 100%; border-collapse: collapse;  margin-top: 10px;">
            <tr style="background-color: #f2f2f2">
              <td style="font-weight: bold;" class="p-10">Comments of HR</td>

            </tr>
            <tr>
              <td class="p-10">
                <textarea rows="3" cols="40" name="comments" [(ngModel)]="hrComment" style="border: hidden;" [readonly]="!(loggedInUserRole=='Super Admin' || 
                 loggedInUserRole=='HR Admin' || 
                 loggedInUserRole=='PHI Admin' || 
                 loggedInUserRole=='MD')" maxlength="255"></textarea>
                <div style="font-size: 12px; text-align: right;">
                  {{ hrComment?.length || 0 }}/255
                </div>
              </td>

            </tr>
          </table>
        </div>
        <div class="mt-10">
          <table border="1" cellpadding="8" cellspacing="0"
            style="width: 100%; border-collapse: collapse;  margin-top: 10px;">
            <tr style="background-color: #f2f2f2">
              <td style="font-weight: bold;" class="p-10">Comments of Employee</td>

            </tr>
            <tr>

              <td class="p-10">
                <textarea rows="3" cols="40" name="comments" [(ngModel)]="employeeComment"
                  [readonly]="(loggedInUserRole!=='Employee' && !checkhodbutEmployee)|| ((loggedInUserRole!=='HOD'||loggedInUserRole!=='Manager')&&!checkhodbutEmployee)||recommandationFrom==''||recommandationFrom==null"
                  maxlength="255" style="border: hidden;"></textarea>
                <div style="font-size: 12px; text-align: right;">
                  {{ employeeComment?.length || 0 }}/255
                </div>
              </td>

            </tr>


          </table>
        </div>

        <div class="mt-10">
          <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content mr-5"
            *ngIf="setUps==''||setUps==null" [style.background-color]="buttonColorName"
            (click)="SaveProbationData( lineManagerOrHODData[0]?.userId)"
            style="display:flex;justify-content:center;align-items:center;text-align:center;">
            save</button>

        </div>
      </div>
    </mat-dialog-content>
  </div>
  <!-- --------------------------------------------------------------------Exit------------------------------------------------------------------------------- -->
  <div class="cardBox " *ngIf="checkType=='addExit'">
    <div class="cardBoxHeading font_medium fs-14 fs_12ForMobile">

      <ion-row>
        <ion-col size="4">
          <div class="formLabelSemiBoldfs16 mb-5">Add Questions </div>
        </ion-col>
        <ion-col size="8" class="text-right">
          <img (click)="closeModal()" class="cp" src="././assets/icon/close_icon.png">
        </ion-col>
      </ion-row>
    </div>

    <mat-dialog-content class="p-0">
      <div style="padding: 0px 8px 8px 8px;">
        <ion-row>
          <!-- Input Field -->
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Questions</div>


            <!-- <mat-form-field class="w-100 mat-height40 mat-input-style"> -->
            <!-- <input matInput [(ngModel)]="fieldName" placeholder="Type here" [maxlength]="255" /> -->
            <textarea rows="3" cols="32" class="edittextareareason w-100 mat-height40 mat-input-style"
              [(ngModel)]="fieldName" [maxlength]="255" maxlength="255"></textarea>
            <!-- </mat-form-field> -->
          </ion-col>

          <!-- Action Buttons -->
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="mt-20">
            <div class="d-flex mt-15">
              <button class="elcm_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                (click)="saveQuestion(null)" [disabled]="!fieldName?.trim()"
                [ngStyle]="{opacity:!fieldName?.trim()?0.5:1}">Save</button>
            </div>
          </ion-col>
        </ion-row>
      </div>


      <div class="p-10">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="table-container scrollable-table">
              <table>
                <thead>
                  <tr>
                    <th>SI<span class="red-cl">&nbsp;*</span></th>
                    <th>Questions<span class="red-cl">&nbsp;*</span></th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of quetionsList; let i = index">
                    <td>{{ i + 1 }}</td>

                    <td *ngIf="editIndex !== i">
                      <!-- {{ item.fieldName }} -->
                      <textarea rows="3" cols="32" class="edittextareareason w-50 mat-height40 mat-input-style"
                        [(ngModel)]=" item.fieldName" [maxlength]="255" maxlength="255" readonly></textarea>
                    </td>
                    <td *ngIf="editIndex === i">

                      <!-- <input matInput [(ngModel)]="editableValueForExitQus" [maxlength]="255" /> -->

                      <textarea rows="3" cols="32" class="edittextareareason w-50 mat-height40 mat-input-style"
                        [(ngModel)]="editableValueForExitQus" [maxlength]="255" maxlength="255"></textarea>

                    </td>

                    <td>
                      <div class="d-flex mt-15">

                        <img *ngIf="editIndex !== i" class="ml-5 cp imgEdit" title="Edit" src="./assets/icon/edit.png"
                          (click)="onClickEditConfirm(i, item)" />

                        <span *ngIf="editIndex === i" (click)="onClickCloseForDays()"
                          class="material-icons close p-10 cp fs-20" title="Cancel Edit">close</span>

                        <span *ngIf="editIndex === i" (click)="saveQuestion(item)"
                          class="material-icons link p-10 cp fs-20" title="Confirm Edit">check</span>
                        <span>

                          <mat-icon class="red-cl" style="width: 40px;" (click)="deleteQuestion(item)">delete</mat-icon>
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>

              </table>
            </div>
          </ion-col>
        </ion-row>
      </div>
    </mat-dialog-content>
  </div>

</div>